export function removeQuotes(str: string) {
  return str.replace(/['"]+/g, "");
}
